import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {ErrorHandlerService} from "../../../error-handler.service";
import {HttpClient} from "@angular/common/http";
import {UserData} from "../../auth/user.data";
import {catchError} from "rxjs";

export class PlanConfig {
    name: string;
}

@Component({
    selector: "fhm-venue-plan-select-control",
    templateUrl: "./venue-plan-select-control.component.html",
    styleUrls: ["./venue-plan-select-control.component.scss"],
    standalone: false
})
export class VenuePlanSelectControlComponent implements OnChanges, OnInit {

    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() label: string;

    @Input() disabled: boolean;

    @Input() customerInstanceId: string;
    @Input() venueId: string;

    public selectedValue: any;

    public options: any[] = [];

    constructor( private http: HttpClient,
                 private auth: AuthApiService,
                 private errorHandler: ErrorHandlerService) {
    }

    ngOnInit(): void {
        this.http.get<PlanConfig[]>("/fonzie/plan-configs", {headers: this.auth.getHttpHeaderOptions()})
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe(data => {
                data.forEach(config => {
                    const record = {label: config.name, value: config.name};
                    this.options.push(record);

                    if (config.name === this.value) {
                        this.selectedValue = record;
                    }
                });
            });
    }

    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
